import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import { red } from '@mui/material/colors';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Box, Button, List, ListItem } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const VeriFyPayment = () => {
	const { t } = useTranslation();
	let navigate = useNavigate();
	return (
		<Box className="mt-32 flex justify-center">
			<Card className="w-1/3">
				<CardHeader
					avatar={
						<Avatar sx={{ bgcolor: red[500] }} aria-label="recipe">
							R
						</Avatar>
					}
					action={
						<IconButton aria-label="settings">
							<MoreVertIcon />
						</IconButton>
					}
					title="Shrimp and Chorizo Paella"
					subheader="September 14, 2016"
				/>
				<CardContent>
					<List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
						<ListItem></ListItem>
					</List>
				</CardContent>
				<CardActions disableSpacing>
					<Button className="w-full" onClick={() => navigate('/')}>
						{t('return_to_home_page')}
					</Button>
				</CardActions>
			</Card>
		</Box>
	);
};

export default VeriFyPayment;
